var map = {
	"./borchia_1.svg": "e902",
	"./borchia_2.svg": "1dc1",
	"./borchia_3.svg": "2e65",
	"./borchia_4.svg": "9b36",
	"./borchia_5.svg": "b85f",
	"./borchia_6.svg": "efed",
	"./borchia_7.svg": "cfe9",
	"./borchia_8.svg": "bf30",
	"./brillante_1.svg": "176a",
	"./brillante_10.svg": "ce45",
	"./brillante_11.svg": "daaa",
	"./brillante_12.svg": "4e43",
	"./brillante_2.svg": "cbf6",
	"./brillante_3.svg": "03f8",
	"./brillante_4.svg": "fe7c",
	"./brillante_5.svg": "3c3c",
	"./brillante_6.svg": "2d10",
	"./brillante_7.svg": "da95",
	"./brillante_8.svg": "6810",
	"./brillante_9.svg": "810a",
	"./charm_1.svg": "0784",
	"./charm_2.svg": "0c3a",
	"./charm_3.svg": "3b54",
	"./charm_4.svg": "7a0c",
	"./charm_5.png": "1e31",
	"./charm_5.svg": "7b16",
	"./charm_6.png": "77f8",
	"./charm_6.svg": "c7da",
	"./charm_7.png": "5021",
	"./charm_7.svg": "4222",
	"./charm_8.png": "b9d9",
	"./charm_9.png": "5f68",
	"./sticker_1.svg": "d8c3",
	"./sticker_10.svg": "0712",
	"./sticker_11.svg": "dff1",
	"./sticker_12.svg": "a810",
	"./sticker_13.svg": "8d75",
	"./sticker_14.svg": "e5a6",
	"./sticker_15.svg": "5309",
	"./sticker_16.svg": "85f8",
	"./sticker_17.svg": "7e0c",
	"./sticker_18.svg": "7d4f",
	"./sticker_19.svg": "beea",
	"./sticker_2.svg": "5794",
	"./sticker_20.svg": "2b18",
	"./sticker_21.svg": "b6d3",
	"./sticker_22.svg": "3db3",
	"./sticker_23.svg": "7c68",
	"./sticker_24.svg": "d32a",
	"./sticker_3.svg": "5ad8",
	"./sticker_4.svg": "da83",
	"./sticker_5.svg": "70a2",
	"./sticker_6.svg": "75ae",
	"./sticker_7.svg": "4726",
	"./sticker_8.svg": "bd00",
	"./sticker_9.svg": "2e08"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ecbd";